import * as Constants from '../common/constants'

const USER_DATA = "user-data"
const LOGIN_STATUS = "login-status"
const RESET_PAGE_READY = "reset-page-ready"

const HEADER_NAME_UPDATE = "header-name-update"
const SUB_HEADER_NAME_UPDATE = "sub-header-name-update"
const LOGOUT_REQUEST = "logout-request"


const EXPIRY_TOKEN_LOGOUT = "expiry-token-logout"
const EXPIRY_TOKEN_MESSAGE = "expiry-token-message"
const BUILD_NUMBER_UPDATE = "build-number-update"



const CONTENTS_IS_UPDATING = "dashboard-contents-is-updating-status"

const initialState = {
    id: 0,
    name: "",
    user_type: "",
    profile_id: 0,
    roles: ["default"],
    privileges: [],

    isResetPageReady:true,
   
    token: "",
    isLogged: false,
    email: "",
    pic: "",
    isOnline: false,
    isFetching: false,
    session_id: "",
    
    headerTitle: "HBB CRM",
    subHeaderTitle: "",
    expiry_token_message: "",
    build_number: "",
    
    isLoading: false,
}

export default function reducer(state = initialState, action) {

    switch (action.type) {
        case USER_DATA:
            let dupliacteState = Object.assign({}, state)

            
            if(action.payload && action.payload.data && action.payload.data.userDetails) {
            return Object.assign({},
                state,
                {
                    id: action.payload.data.userDetails.id,
                    name: action.payload.data.userDetails.profile_name,
                    user_type: action.payload.data.userDetails.user_type,
                    build_number:action.payload.app_build_no,
                    profile_id: action.payload.data.userDetails.profile_id,
                    token: action.payload.data.token,
                    roles: action.payload.data.userDetails.roles,
                    privileges: action.payload.data.userDetails.privileges,
                    mqtt_details:action.payload.data.userDetails.mqtt
                    
                })
            }
            return dupliacteState

        

        case LOGIN_STATUS:
            return Object.assign({}, state, { isLogged: action.payload })

        case RESET_PAGE_READY:
            return Object.assign({}, state, { isResetPageReady: action.payload })

            

        case HEADER_NAME_UPDATE:
            dupliacteState = Object.assign({}, state)
            if (dupliacteState.headerTitle !== action.payload) {
                return Object.assign({}, state, { headerTitle: action.payload })
            } else {
                return state
            }

        case SUB_HEADER_NAME_UPDATE:
            dupliacteState = Object.assign({}, state)
            if (dupliacteState.subHeaderTitle !== action.payload) {
                return Object.assign({}, state, { subHeaderTitle: action.payload })
            } else {
                return state
            }

        case LOGOUT_REQUEST:
            localStorage.removeItem(Constants.HBB_STORE_NAME)
            return Object.assign({}, state, { isLogged: false })

        case EXPIRY_TOKEN_LOGOUT:
            return Object.assign({}, state, { isLogged: action.payload })
        
        case EXPIRY_TOKEN_MESSAGE:
            dupliacteState = Object.assign({}, state)
            dupliacteState.expiry_token_message = action.payload
            return dupliacteState
        
        case BUILD_NUMBER_UPDATE:
            dupliacteState = Object.assign({}, state)
            dupliacteState.build_number = action.payload
            return dupliacteState

        case CONTENTS_IS_UPDATING:
            return Object.assign({}, state, { isLoading: action.payload })
            
        default:
            return state
    }
}




export function resetPageReady(data) {
    return {
        type: RESET_PAGE_READY,
        payload: data
    }
}
export function userDataUpdate(data) {
    return {
        type: USER_DATA,
        payload: data
    }
}

export function loginStatusUpdate(data) {
    return {
        type: LOGIN_STATUS,
        payload: data
    }
}



export function headerDataUpdate(data) {
    return {
        type: HEADER_NAME_UPDATE,
        payload: data
    }
}

export function subHeaderDataUpdate(data) {
    return {
        type: SUB_HEADER_NAME_UPDATE,
        payload: data
    }
}



export function logoutRequest(payload) {
    return {
        type: LOGOUT_REQUEST,
        payload: payload
    }
}



export function expiryTokenlogout(status) {
    return {
        type: EXPIRY_TOKEN_LOGOUT,
        payload: status
    }
}

export function expiryTokenMessageUpdate(message) {
    return {
        type: EXPIRY_TOKEN_MESSAGE,
        payload: message
    }
}

export function buildNumberUpdate(buildNum) {
    return {
        type: BUILD_NUMBER_UPDATE,
        payload: buildNum
    }
}

export function isContentsLoadingUpdate(status) {
    return {
        type: CONTENTS_IS_UPDATING,
        payload: status
    }
}


// WEBPACK FOOTER //
// ./src/redux/user.js